enum Carriers {
  ASENDIA = 'asendia',
  BRING = 'bring',
  CITYMAIL = 'citymail',
  DEUTSCHE_POST = 'deutschepost',
  LETTER_CARRIER = 'letter_carrier',
  DHL_FREIGHT = 'dhl_freight',
  DHL_EXPRESS = 'dhl_express',
  EARLYBIRD = 'earlybird',
  POSTNORD = 'postnord',
  POSTI = 'posti',
  UPS = 'ups',
}

export default Carriers
